import request from "@/utils/request";

export const getDefaultModelQuota = () => request({ url: "/user/default-model-quota", method: "get" });
